import { useContent } from "../ContentContext";

const ContactSection = () => {
  const content = useContent();

  return (
    <section className="bg-light text-dark py-12 px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 items-start flex flex-col justify-center h-full ">
        {/* Logo */}
        <div className="pb-6">
          <img src="/images/logo.png" alt="Firethorn Logo" className="h-20" />
        </div>

        {content.contactinfo.locations.map((location, index) => (
          <div key={index} className="pb-2">
            <h3 className="font-poppins font-bold uppercase text-secondary">{location[0]}</h3>
            <p className="font-garet">
              {location[1]}
              <br />
              {location[2]}
              <br />
              {location[3]}
            </p>
          </div>
        ))}


        {/* Phone */}
        <div className="pb-2">
          <h3 className="font-poppins font-bold  uppercase text-secondary">Phone</h3>
          <a href={`tel:+1${content.contactinfo.phone}`} className="font-garet">{content.contactinfo.phone}</a>
        </div>

        {/* Email */}
        <div>
          <h3 className="font-poppins font-bold uppercase text-secondary">Email</h3>
          <a href={`mailto:${content.contactinfo.email}`} className="font-garet">{content.contactinfo.email}</a>
        </div>
        
      </div>
    </section>
  );
};

export default ContactSection;
